import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';
import config from 'config/index';
// types
import { EUserType } from 'types/accessControll.types';

const reducerPath = 'media' as const;
const path = 'v1/media' as const;

export const mediaApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  endpoints: (builder) => ({
    uploadMedia: builder.mutation<
      any,
      {
        formData: FormData;
        clientId: string;
      }
    >({
      query: (x) => {
        console.log('x', x);
        return {
          url: `/${x.clientId}/upload`,
          method: 'POST',
          data: x.formData,
          body: x.formData,
          files: x.formData,
          contentType: false,
          processData: false,
          enctype: 'multipart/form-data',
          //cache: false,
          formData: true,
          headers: {
            'X-Access-Control': EUserType.HUBERT,
          },
        };
      },
    }),

    getMedia: builder.query<
      {
        message: string;
        files: {
          id: string;
          contentType: string;
          name: string;
          size: string | number;
          updated: Date;
          url: string;
        }[];
      },
      {
        clientId: string;
      }
    >({
      query: (x) => {
        console.log('x', x);
        return {
          url: `/${x.clientId}`,
          method: 'GET',
          headers: {
            'X-Access-Control': EUserType.HUBERT,
          },
        };
      },
    }),

    deleteMedia: builder.mutation<
      {
        success: boolean;
      },
      {
        clientId: string;
        fileId: string;
      }
    >({
      query: (x) => {
        console.log('x', x);
        return {
          url: `/${x.clientId}/${x.fileId}`,
          method: 'DELETE',
          headers: {
            'X-Access-Control': EUserType.HUBERT,
          },
        };
      },
    }),
  }),
});

export const {
  // Queries
  useGetMediaQuery,
  // Mutations
  useDeleteMediaMutation,
  useUploadMediaMutation,
} = mediaApi;
